import { Link } from 'react-router-dom';
import './Top.scss';

interface TopProps {
    header: string
    text: string
    btn?: string
    classParent: string
    text2?: string
    phone?: string
}

const Top: React.FC<TopProps> = ({header, text, text2, phone, btn, classParent}) => {
    return (
      <section className={`${classParent} top`}>
        <div className="top-img">
          <div className="container">
            <div className="top-filling">
              <h2 className="top-header">{header}</h2>
              <p className="top-text">{text}</p>
              {text2 ? <p className="top-text">{text2}</p> : <></>}
              {text2 ? 
              <div className="top-phone">
                <p>
                    Телефон:
                </p>
                <a href={`tel:${phone}`}>
                    {phone}
                </a>
              </div> 
              : <></>}
              {btn ? (
                <Link to="/contacts" className="top-btn">
                  {btn}
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </section>
    );
}

export default Top;